import { render } from "./Review-index.vue?vue&type=template&id=a81f771e"
import script from "./Review-index.vue?vue&type=script&lang=js"
export * from "./Review-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__